module.exports = __webpack_public_path__ + "static/media/e5716290-d41e-4c97-a27c-7a20a46ddf45.9eef8add.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/e5716290-d41e-4c97-a27c-7a20a46ddf45.woff2
// module id = 84
// module chunks = 0